<template>
	<div class="pulls-wrapper" v-if="pullList.length > 0">
		<h2>
			<span class="header-icon"></span>
			<span class="text">Pull Requests: {{pullCount}}</span>
		</h2>
		<div v-for="p in pullList" v-bind:key="p.pullRequestId" class="pull" v-bind:class="getClass(p)">
			<div class="description">{{p.description}}</div>
			<div class="metrics">
				<span class="conflict" v-if="p.conflicts">Conflicts</span>
				<i class="fas fa-code-branch fa-lg fa-fw"></i>
				{{p.sourceBranch}}
				<i class="fas fa-arrow-right fa-lg fa-fw"></i>
				{{p.targetBranch}}
			</div>
			<div class="details">{{p.repository}} - {{p.user}} - {{p.relativeDateString}}</div>
		</div>
		<div class="show-more" v-if="moreCount > 0"><i class="fas fa-arrow-down fa-lg"></i> {{moreCount}} more</div>
	</div>
	<div class="pulls-wrapper empty" v-else>
		<img src="/images/pusheen.png" />
		<div class="text">No Pull Requests</div>
	</div>
</template>

<script>
	import Bugsnag from '@bugsnag/js'

	let azurePulls = null;
	let githubPulls = null;

	export default {
		name: 'DevPulls',

		data() {
			return {
				azureList: [],
				githubList: [],
				pullList: [],
				pullCount: 0,
				moreCount: 0
			};
		},

		mounted() {
			console.log("Development pull request module initiated");
			this.refreshAzurePullRequests();
			this.refreshGithubPullRequests();
			azurePulls = setInterval(this.refreshAzurePullRequests, 60000);
			githubPulls = setInterval(this.refreshGithubPullRequests, 60000);
		},
		
		destroyed() {
			console.log("Stopping Development pull request module");
			clearInterval(azurePulls);
			clearInterval(githubPulls);
		},
		
		methods: {

			refreshAzurePullRequests() {
				let self = this;
				self.$http.get('/code/azure-pulls', {}).then(response => {
					let data = response.body;
					self.azureList = data;
					self.compileList();
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});

			},

			refreshGithubPullRequests() {
				let self = this;
				self.$http.get('/code/github-pulls', {}).then(response => {
					let data = response.body;
					self.githubList = data;
					self.compileList();
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});

			},

			compileList() {
				let fullList = [];
				for (let x = 0; x < this.azureList.length; x++) fullList.push(this.azureList[x]);
				for (let x = 0; x < this.githubList.length; x++) fullList.push(this.githubList[x]);
				fullList.sort((a, b) => {
					return new Date(a.date) - new Date(b.date);
				});
				this.pullCount = fullList.length;
				this.moreCount = this.pullCount - 8;

				this.pullList = fullList.slice(0, Math.min(8, fullList.length));
			},

			getClass(pull) {
				if (pull.vote > 0) return "pull-ready";
				if (pull.vote < 0) return "pull-await";
				if (pull.stale) return "pull-stale";
				return "pull-normal";
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '../../less/_variables.less';

	@bg-pull-normal: #3683FF;
	@bg-pull-await: #B24434;
	@bg-pull-stale: #B5871D;
	@bg-pull-ready: #7FA750;
	@bg-conflict: #B24434;

	.pulls-wrapper {
		padding: 2%;
		width: 33%;
		height: 100%;
		position: relative;
	}

	.build-icon {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		top: 0;
		width: 15%;
		height: 100%;
		background-size: 70%;
		background-position: center center;
		background-repeat: no-repeat;
	}

	.github {
		background-image: url(images/github.svg);
	}

	.azure {
		background-image: url(images/visual-studio.svg);
	}

	.pull {
		border-radius: @border-radius;
		margin-top: 0.3em;
		padding: 0.6em 1em;
		position: relative;
	}

	.pull-await {
		background-color: @bg-pull-await;
	}

	.pull-stale {
		background-color: @bg-pull-stale;
	}

	.pull-normal {
		background-color: @bg-pull-normal;
	}

	.pull-await {
		background-color: @bg-pull-await;
	}

	.pull-stale {
		background-color: @bg-pull-stale;
	}

	.pull-ready {
		background-color: @bg-pull-ready;
	}

	.conflict {
		display: inline-block;
		background-color: @bg-conflict;
		font-size: 0.8em;
		line-height: 1.1em;
		padding: 0.4em;
		border-radius: 0.5em;
		text-transform: uppercase;
		margin-right: 0.5em;
	}

	.pull-await .conflict {
		background-color: #fff;
		color: @bg-conflict;
	}

	.description {
		font-weight: 700;
		font-size: 1.2em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.metrics {
		line-height: 1.4em;
		padding-top: 0.2em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.metric-item {
		display: inline-block;
		padding-left: 0.3em;
	}

	.details {
		line-height: 1.4em;
		padding-top: 0.2em;
		opacity: 0.6;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	h2 {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin: 0;
		font-size: 2em;
		line-height: 1em;

		span.header-icon {
			background-size: contain;
			background-position: center center;
			background-repeat: no-repeat;
			width: 1.7em;
			height: 1.7em;
			background-image: url(images/pulls.svg);
		}

		span.text {
			text-transform: uppercase;
			padding-left: 0.5em;
		}
	}

	.show-more {
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		padding: 1.5em;
		font-size: 1.8em;
		text-align: center;
		background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 30%);
	}

	.empty {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-flow: column nowrap;

		img {
			width: 100%;
			height: auto;
		}

		.text {
			padding-top: 2em;
			font-size: 2em;
		}
	}
</style>


// WEBPACK FOOTER //
// dev-pulls.vue?7356b19c